import { action } from 'typesafe-actions';
import { IUser } from '../user/types';
import {
  Types,
  IBlock,
  IPurchaseReceiver,
  ICustomer,
  ECreditRenewStatus,
  IProductDescriptionResponse
} from './types';

export const loadCustomers = (user: IUser) =>
  action(Types.LOAD_CUSTOMERS, { user });
export const loadCustomersSuccess = (customers: ICustomer[]) =>
  action(Types.LOAD_CUSTOMERS_SUCCESS, { customers });
export const loadCustomersFailure = (error: unknown) =>
  action(Types.LOAD_CUSTOMERS_FAILURE, { error });

export const loadCustomerFromId = (selectedCustomerId: string) =>
  action(Types.LOAD_CUSTOMER_BY_ID, { selectedCustomerId });
export const loadCustomerFromIdSuccess = (customer: ICustomer) =>
  action(Types.LOAD_CUSTOMER_BY_ID_SUCCESS, { customer });
export const loadCustomerFromIdFailure = (error: unknown) =>
  action(Types.LOAD_CUSTOMER_BY_ID_FAILURE, { error });

export const setCreditRenewCode = (
  selectedCustomerId: string,
  creditRenewCode: string,
  creditRenewRequestId: string,
  creditRenewRequestStatus: ECreditRenewStatus
) =>
  action(Types.SET_CREDIT_RENEW_CODE, {
    selectedCustomerId,
    creditRenewCode,
    creditRenewRequestId,
    creditRenewRequestStatus
  });

export const loadCustomersProductDescription = (selectedCustomerId: string) =>
  action(Types.LOAD_CUSTOMER_PRODUCTS_DESCRIPTION, {
    selectedCustomerId
  });
export const loadCustomersProductDescriptionV2 = (selectedCustomerId: string) =>
  action(Types.LOAD_CUSTOMER_PRODUCTS_DESCRIPTION_V2, {
    selectedCustomerId
  });
export const loadCustomersProductDescriptionSuccess = (
  productsDescriptionResponse: IProductDescriptionResponse,
  selectedCustomerId: string
) =>
  action(Types.LOAD_CUSTOMER_PRODUCTS_DESCRIPTION_SUCCESS, {
    productsDescriptionResponse,
    selectedCustomerId
  });
export const loadCustomersProductDescriptionFailure = (error: unknown) =>
  action(Types.LOAD_CUSTOMER_PRODUCTS_DESCRIPTION_FAILURE, { error });

export const loadCustomerBlocks = (selectedCustomerId: string) =>
  action(Types.LOAD_CUSTOMER_BLOCKS, { selectedCustomerId });
export const loadCustomerBlocksSuccess = (
  customerBlocks: IBlock[],
  selectedCustomerId: string
) =>
  action(Types.LOAD_CUSTOMER_BLOCKS_SUCCESS, {
    customerBlocks,
    selectedCustomerId
  });
export const loadCustomerBlocksFailure = (error: unknown) =>
  action(Types.LOAD_CUSTOMER_BLOCKS_FAILURE, { error });

export const loadCustomerPurchaseReceivers = (selectedCustomerId: string) =>
  action(Types.LOAD_CUSTOMER_PURCHASE_RECEIVERS, { selectedCustomerId });
export const loadCustomerPurchaseReceiversSuccess = (
  receivers: IPurchaseReceiver[],
  selectedCustomerId: string
) =>
  action(Types.LOAD_CUSTOMER_PURCHASE_RECEIVERS_SUCCESS, {
    receivers,
    selectedCustomerId
  });
export const loadCustomerPurchaseReceiversFailure = (error: unknown) =>
  action(Types.LOAD_CUSTOMER_PURCHASE_RECEIVERS_FAILURE, { error });

export const cleanErrors = () => action(Types.CLEAN_ERRORS);
